<template>
    <div class="loading-container"></div>
</template>

<script lang="ts">
import Vue from "vue";
import { BookmarkFactory, serializeBookmark } from "@/views/viz/viz";
import { VizSensor } from "@/views/viz/api";

export default Vue.extend({
    name: "ExploreModuleLoader",
    props: {
        stationId: {
            type: Number,
            required: true,
        },
        moduleKey: {
            type: String,
            required: true,
        },
    },
    async mounted() {
        try {
            const [quickSensorsResponse, tailData] = await Promise.all([
                this.$services.api.getQuickSensors([this.stationId]),
                this.$services.api.tailSensorData([this.stationId]),
            ]);
            const quickSensors = quickSensorsResponse.stations[this.stationId];
            const matchingSensors = quickSensors.filter((qs) => qs.moduleKey === this.moduleKey && qs.moduleId != null);

            let bm;
            const sensorWithData = matchingSensors.find((sensor) => tailData.data.some((row) => row.sensorId == sensor.sensorId));

            const twoWeeks = 14 * 86400000;
            if (sensorWithData) {
                const sensorData = tailData.data.filter((row) => row.sensorId == sensorWithData.sensorId);
                const vizSensor: VizSensor = [this.stationId, [sensorWithData.moduleId, sensorWithData.sensorId]];
                const lastReading = Math.max(...sensorData.map((row) => row.time));
                bm = BookmarkFactory.forSensor(this.stationId, vizSensor, [lastReading - twoWeeks, lastReading]);
            } else if (matchingSensors.length > 0) {
                const sensor = matchingSensors[0];
                const vizSensor: VizSensor = [this.stationId, [sensor.moduleId, sensor.sensorId]];
                const recently = await this.$services.api.queryStationsRecently([this.stationId]);
                const lastTimestamp = recently.stations[this.stationId]?.last;
                const endTime = lastTimestamp || Date.now();
                bm = BookmarkFactory.forSensor(this.stationId, vizSensor, [endTime - twoWeeks, endTime]);
            } else {
                bm = BookmarkFactory.forStation(this.stationId);
            }

            const encoded = serializeBookmark(bm);
            const savedBookmark = await this.$services.api.saveBookmark(encoded);
            this.$router.replace({
                name: "exploreShortBookmark",
                query: { v: savedBookmark.token },
            });
        } catch (error) {
            console.error("ExploreModuleLoader - error:", error);
            const bm = BookmarkFactory.forStation(this.stationId);
            this.$router.replace({
                name: "exploreBookmark",
                query: { bookmark: serializeBookmark(bm) },
            });
        }
    },
});
</script>

<style scoped lang="scss">
.loading-container {
    min-height: 100vh;
}
</style>
